export const FILTER_TYPES = {
  ORGANIZATION: 'organization',
  ROLE: 'role',
  LOCATION: 'location',
  STATUS: 'status',
  DOMAIN: 'domain',
  SORT: 'sort'
};

export const SORT_OPTIONS = [
  { value: null, label: 'Sort' },
  { value: 'newest', label: 'Newest First' },
  { value: 'oldest', label: 'Oldest First' },
  { value: 'status', label: 'By Status' },
  { value: 'active', label: 'Active First' },
  { value: 'waitlist', label: 'Waitlist First' },
  { value: 'submitted', label: 'Submitted First' }
];

export const STATUS_TYPES = {
  ACTIVE: 'active',
  WAITLIST: 'waitlist',
  SUBMITTED: 'submitted'
};

export const DOMAIN_TYPES = {
  COMMON: 'Common Email Providers',
  CUSTOM: 'Custom'
};

export const COMMON_EMAIL_DOMAINS = ['@gmail.com', '@hotmail.com', '@yahoo.com']; 